// hooks/useRemoveMemberFromLeague.js
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export const useRemoveMemberFromLeague = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ leagueId, userId }) => {
      const apiUrl = process.env.REACT_APP_API_URL; // Ensure this is set in your environment variables
      const token = await getAccessTokenSilently();

      // Note: The second argument to axios.delete() is the config object where you can set headers
      const response = await axios.delete(
        `${apiUrl}/api/league/${leagueId}/${userId}/remove`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    },
    {
      onSuccess: (data, variables) => {
        // Destructuring inside the function body
        const { leagueId } = variables;
        queryClient.invalidateQueries(["leagueDetails", leagueId]);
        queryClient.invalidateQueries(["leagueMembers", leagueId]);
      },
      onError: (error, variables) => {
        // Destructuring inside the function body
        const { leagueId } = variables;
        console.error(
          `Error removing member from league with ID ${leagueId}:`,
          error.response?.data?.message || "An error occurred."
        );
      },
    }
  );
};

export default useRemoveMemberFromLeague;
